import { SaF } from '@yes.technology/react-toolkit'
import styled from 'styled-components'
import { Title } from '../Cockpit.styles'

export type SaFChartProps = {
  data: React.ComponentProps<typeof SaF>
  title: string
}

const Container = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
`

const SaFChart = ({ data, title }: SaFChartProps) => {
  const getErrorType = () => {
    const hasEmptyNodes = data?.data?.nodes?.length < 1
    const hasInvalidData = !data || !data?.data

    if (hasInvalidData) {
      return 'invalid-data'
    }

    if (hasEmptyNodes) {
      return 'no-data'
    }
  }

  const error = getErrorType()

  return (
    <Container>
      <Title>{title}</Title>
      <SaF columns={data.columns} data={data.data} error={error} />
    </Container>
  )
}

export default SaFChart
